import { IBaseCanvasInjectable } from '@src/slide/application/service/canvas-component/inject/base/interface';

export default class BaseCanvasInjectable implements IBaseCanvasInjectable {
    public isHeaderFold(): boolean | undefined {
        return false;
    }

    public isStatusBarFold(): boolean {
        return false;
    }
}
